import {BLOGS_LOADING,SET_BLOGS} from './types';

const setLoading = () => {
    return {
        type:BLOGS_LOADING
    }
};
const setBlogs = data => {
    return {
        type:SET_BLOGS,
        payload:data
    }
};
export const loadBlogs = data => {
    return dispatch => {
        dispatch(setLoading());
        return dispatch(setBlogs(data));
    };
};